import { ApiPath } from "enums";
import { Get, Post } from "utils";

export const MULTI_CAMPAIGN_CHAT_KIND = "multi";

const unwrap = (result) => result?.data ?? result;

export const createChatThread = async ({ campaignCode, campaignCodes, kind } = {}) => {
  let body;
  if (kind === MULTI_CAMPAIGN_CHAT_KIND) {
    const codes = Array.isArray(campaignCodes) ? campaignCodes : [];
    const normalized = codes.map((code) => String(code).trim().toLowerCase());
    if (
      codes.length < 1 ||
      codes.length > 10 ||
      codes.some((code) => typeof code !== "string" || !code.trim()) ||
      normalized.some((code, index) => normalized.indexOf(code) !== index)
    ) {
      throw new Error("Choose 1 to 10 campaigns with no duplicate codes.");
    }
    body = { kind, campaignCodes: [...codes] };
  } else {
    body = campaignCodes ? { campaignCodes: [...campaignCodes] } : { campaignCode };
  }

  if (kind && kind !== MULTI_CAMPAIGN_CHAT_KIND) {
    body.kind = kind;
  }

  const thread = unwrap(await Post(ApiPath.SurveyChatThread, body));
  // Server may omit `kind` on multi-campaign threads.
  return kind === MULTI_CAMPAIGN_CHAT_KIND && thread && !thread.kind ? { ...thread, kind } : thread;
};

export const getChatThreads = async ({ campaignCode, kind, page = 1, perPage = 20 } = {}) => {
  const params = {
    campaignCode,
    page,
    perPage,
  };

  if (kind) {
    params.kind = kind;
  }

  if (kind === MULTI_CAMPAIGN_CHAT_KIND) delete params.campaignCode;

  return unwrap(await Get(ApiPath.SurveyChatThread, params));
};

export const getChatThreadMessages = async ({ insightChatThreadId, page = 1, perPage = 20 }) => {
  return unwrap(
    await Get(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, {
      page,
      perPage,
    }),
  );
};

export const createChatThreadMessage = async ({ insightChatThreadId, prompt, mapScope }) => {
  const body = { prompt };

  if (mapScope) {
    body.mapScope = mapScope;
  }

  return unwrap(await Post(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, body));
};
